import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from '../helpers/CommonHelpers';
import { headerAutoComplete } from '../redux/slices/searchActions';
import SearchSuggestions from '../components/SearchSuggestions';
import { buildURL, getDefaultSort } from '../utils/searchFunctions';
import { setOptions, setHeaderAutocompleteResults, setIsClearFilter } from '../redux/slices/search.slice';

export default function HeaderSearchBar() {
  const dispatch = useDispatch();
  const { userId = 0, isLoggedIn = false } = window.IM_SEARCH_DATA || {};
  const loggedIn = Boolean(Number(isLoggedIn));
  const [searchQuery, setSearchQuery] = useState('');
  const headerResults = useSelector(state => state.search.headerAutocompleteResults);
  const headerLoading = useSelector(state => state.search.headerAutocompleteLoading);
  const searchOptions = useSelector(state => state.search.searchOptions);
  const isClearFilter = useSelector(state => state.search.isClearFilter);
  const [showSearchSuggestion, setShowSearchSuggestion] = useState(false);
  
  const filterSearchRef = useRef(null);

  useEffect(() => {
    if (isClearFilter) {
      setSearchQuery('');
      dispatch(setIsClearFilter(false));
    }
  }, [isClearFilter, dispatch]);

  const getAutocompleteResults = (query) => {
    if (query.trim() !== '') {
      dispatch(headerAutoComplete({ searchQuery: query }));
    } else {
      dispatch(setHeaderAutocompleteResults({}));
    }
  };

const searchContent = (query) => {
    const cleanQuery = query.trim();
    if (!cleanQuery) return; // Prevent empty searches

    let options = {
      ...searchOptions,
      searchQuery: cleanQuery,
      // Pass the inverse of isLoggedIn to options
      isPublicSearch: !loggedIn, 
      licensing_Tech: null,
      products: null,
      subjectArea: null,
      skip: 0,
      take: 8,
    };

    const defaultSort = getDefaultSort(options);
    options = { ...options, sortBy: defaultSort };

    dispatch(setOptions(options));
    const urlOptions = buildURL(options);
    const baseUrl = loggedIn ? '/atlas/search' : '/search';
    window.location.assign(`${baseUrl}?${urlOptions}`);
  };

  useEffect(() => {
    const handleMouseDown = (e) => {
      if (filterSearchRef.current && !filterSearchRef.current.contains(e.target)) {
        setShowSearchSuggestion(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, []);

  return (
    <div  className="w-100"  ref={filterSearchRef}>
      <form 
        className="w-100 d-flex justify-content-between gap-1" 
        onSubmit={(e) => {
          e.preventDefault();
          searchContent(searchQuery);
          setShowSearchSuggestion(false);
        }}
      >
        <input
          className='w-100'
          type="text"
          name="q"
          autoComplete="off"
          placeholder="Search"
          value={searchQuery}
          onFocus={() => setShowSearchSuggestion(true)}
          onChange={(e) => {
            const value = e.target.value;
            setSearchQuery(value);
            debounce(() => getAutocompleteResults(value), 100);
          }}
        />
        <button type="submit" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M15 8.125C15 5.70312 13.6719 3.4375 11.5625 2.1875C9.41406 0.976562 6.79688 0.976562 4.6875 2.1875C2.53906 3.4375 1.25 5.70312 1.25 8.125C1.25 10.5859 2.53906 12.8516 4.6875 14.1016C6.79688 15.3125 9.41406 15.3125 11.5625 14.1016C13.6719 12.8516 15 10.5859 15 8.125ZM13.3984 14.2969C11.9922 15.5469 10.1172 16.25 8.125 16.25C3.63281 16.25 0 12.6172 0 8.125C0 3.67188 3.63281 0 8.125 0C12.5781 0 16.25 3.67188 16.25 8.125C16.25 10.1562 15.5078 11.9922 14.2969 13.4375L19.8047 18.9453C20.0391 19.1797 20.0391 19.6094 19.8047 19.8438C19.5703 20.0781 19.1406 20.0781 18.9062 19.8438L13.3984 14.2969Z" fill="#2D2D2D" />
          </svg>
        </button>
      </form>

      {showSearchSuggestion && (
        <div className='search-dropdown' style={{ position: 'absolute', top: '100%', left: 0, width: '100%', zIndex: 999 }}>
          <SearchSuggestions 
            searchQuery={searchQuery} 
            setShowSearchSuggestion={setShowSearchSuggestion} 
            isPublicSearch={!loggedIn}
            customResults={headerResults}
            customLoading={headerLoading}
          />
        </div>
      )}
    </div>
  );
}